'use strict';
module.exports = function combineCondensedVerticalSubtrees(node, childLayouts, margin) {

	const result = {
			nodes: { }
		},
		rankSort = (x, y) => parseFloat(x) - parseFloat(y),
		shift = function (nodes) {
			Object.values(nodes).forEach(childNode => {
				childNode.x += margin.h;
				childNode.verticalOffset += result.condensedHeight + margin.v;
			});
			return nodes;
		};


	if (Array.isArray(childLayouts)) {
		throw 'child layouts are an array!';
	}
	result.condensedHeight = node.height;
	result.condensedWidth = node.width;
	result.nodes[node.id] = node;
	result.leftAligned = true;


	Object.keys(childLayouts).sort(rankSort).forEach((subtreeRank) => {

		Object.assign(result.nodes, shift(childLayouts[subtreeRank].nodes));
		result.condensedHeight += childLayouts[subtreeRank].condensedHeight + margin.v;
		result.condensedWidth = Math.max(result.condensedWidth, childLayouts[subtreeRank].condensedWidth + margin.h);
	});
	node.x = 0;

	result.levels = [{width: result.condensedWidth, xOffset: 0}];
	return result;
};
